import { Icon } from "PFComponents/icon";
import { useWindowSize } from "PFCore/helpers/use_window_size";
import { useTranslation } from "react-i18next";

import css from "./footer.module.scss";

const NARROW_WINDOW_WIDTH = 320;

export const HotBadge = () => {
  const { t } = useTranslation();
  const { windowWidth } = useWindowSize();

  return (
    <div className={css.icons}>
      <Icon name="fire" size="md" color="paletteOrange0" />
      <div>&nbsp;{windowWidth > NARROW_WINDOW_WIDTH ? t("hotDescription") : t("hot")}</div>
    </div>
  );
};
